import { api } from '../../../system/api';

export default {
    getCategories: params => api.get(`/merchant/products/categories`, { params, singleRequest: true, loading: false }),
};
